//文字コードはutf-8

/**
 * FAQアコーディオン
 * クリックで開閉するアコーディオン機能
 * AIO（アクセシビリティ）に最適化
 */
export const initFaqAccordion = () => {
  const faqItems = document.querySelectorAll('.modBlockFaq__item');
  
  if (!faqItems.length) return;

  const openItems = [];

  faqItems.forEach((item) => {
    const button = item.querySelector('.heading__btn');
    const answer = item.querySelector('.answer');
    const contentId = button?.getAttribute('aria-controls');

    if (!button || !answer || !contentId) return;

    const isInitiallyOpen = item.classList.contains('is-open');
    button.setAttribute('aria-expanded', isInitiallyOpen ? 'true' : 'false');

    if (isInitiallyOpen) {
      answer.hidden = false;
      answer.style.opacity = '1';
      answer.style.visibility = 'visible';
      requestAnimationFrame(() => {
        answer.style.maxHeight = `${answer.scrollHeight}px`;
      });
    } else {
      answer.hidden = true;
      answer.style.maxHeight = '0px';
      answer.style.opacity = '0';
      answer.style.visibility = 'hidden';
    }

    const openItem = () => {
      if (item.classList.contains('is-open')) return;
      item.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      answer.hidden = false;
      answer.style.maxHeight = '0px';
      answer.style.opacity = '1';
      answer.style.visibility = 'visible';
      requestAnimationFrame(() => {
        answer.style.maxHeight = `${answer.scrollHeight}px`;
      });
    };

    const closeItem = () => {
      if (!item.classList.contains('is-open')) return;
      item.classList.remove('is-open');
      button.setAttribute('aria-expanded', 'false');
      answer.style.maxHeight = `${answer.scrollHeight}px`;
      requestAnimationFrame(() => {
        answer.style.maxHeight = '0px';
      });

      const handleTransitionEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        answer.hidden = true;
        answer.style.opacity = '0';
        answer.style.visibility = 'hidden';
        answer.removeEventListener('transitionend', handleTransitionEnd);
      };

      answer.addEventListener('transitionend', handleTransitionEnd);
    };

    const toggleAccordion = () => {
      if (item.classList.contains('is-open')) {
        closeItem();
      } else {
        openItem();
      }
    };

    button.addEventListener('click', (event) => {
      event.preventDefault();
      toggleAccordion();
    });

    button.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleAccordion();
      }
    });

    const maintainHeight = (event) => {
      if (event.propertyName !== 'max-height' || !item.classList.contains('is-open')) return;
      answer.style.maxHeight = `${answer.scrollHeight}px`;
    };

    answer.addEventListener('transitionend', maintainHeight);

    openItems.push({ item, answer });
  });

  let resizeTimer;
  const updateOpenHeights = () => {
    openItems.forEach(({ item, answer }) => {
      if (!item.classList.contains('is-open') || answer.hidden) return;
      answer.style.maxHeight = `${answer.scrollHeight}px`;
    });
  };

  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(updateOpenHeights, 150);
  });
};


